export default "__VITE_ASSET__BNL$0m8p__"